import angular from 'angular';

import RemoveUserModalConf from './remove-user.config';
import RemoveUserController from './remove-user.controller';
import CurrentCustomer from '../../models/customer';
import CurrentUser from '../../models/user';
import Member from '../../models/member';


export default angular.module('modal.remove-user', [CurrentCustomer,
    CurrentUser, Member
  ])
  .controller('RemoveUserController', RemoveUserController)
  .constant('RemoveUserModalConf', RemoveUserModalConf)
  .name;



// WEBPACK FOOTER //
// ./project/modals/remove-user/index.js